import { React, Field, ErrorMessage, errorMessagesSection, FontAwesomeIcon,
         faExclamationCircle, infoPlaceholderSection, InputStyle, FormStyle }
         from "@/imports-files/components/input";
import { getIn } from "formik";

export function Input(props)
{
      const { label, name, infoPlaceholder, errorClass, style, type, noError,customFontFamily, ...rest } = props;
const error = getIn(props.formik.errors, name);
const touched = getIn(props.formik.touched, name);

      return (
                < div className= {`${InputStyle.Form__InputSection} ${props.extraClass}`}>
                  { props.isCurrency && <span>$</span> }
                  < Field name = { name } type = { type } style={style} { ...rest}/>
                  {
  noError ? null :
  touched && error
    ? errorMessagesSection(name, FormStyle, props.formik, props.custom_class || '', props.custom_error_90 || '',customFontFamily)
    : infoPlaceholderSection(infoPlaceholder, FormStyle,props.customCss, props.PlaceholderClass)
}

                </div>
             );
}

export function ScoreCardInput(props)
{
      const { label, name, infoPlaceholder, errorClass, style, type, ...rest } = props;
      
      return (
                < div className= {InputStyle.Form__ScoreCardInput}>
                  { props.isCurrency && <span>$</span> }
                  < Field name = { name } type = { type } style={style} { ...rest}/>
                  {

                    style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '')
                                       :  ''
                  }
                </div>
             );
}

export function AutocompleteError(props){
  const {style, errorClass, infoPlaceholder, name,customFontFamily, ...rest} = props
  return (
  style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '', props.custom_error_90 || '', customFontFamily)
                                       :  infoPlaceholderSection(infoPlaceholder, FormStyle)
  )
}

export function CustomAutocompleteError(props){
  const {style, errorClass, infoPlaceholder, name, ...rest} = props
  return (
  style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '')
                                       :  ''
  )
}

